import React from 'react';
import './RadioVerTwo.css';
import tr from '../../../libs/tr'
import { BrowserView, MobileView, isBrowser, isMobile, isFirefox, isTablet, isMobileOnly, isAndroid, isIOS, browserName } from 'react-device-detect';

class RadioVerTwo extends React.Component {
    constructor(props) {
        super();

        this.state = {
            context01: props.context01,
            context01details: props.context01details,
            context02: props.context02,
            context02details: props.context02details,
            radio1: true,
            radio2: false,

            justFirst: props.justFirst ? props.justFirst : "true",
            justSecond: props.justSecond ? props.justSecond : "true",

        };

        console.log('[RadioVerTwo son]', props);
        this.RadioVerTwoCB = this.RadioVerTwoCB.bind(this);

        this.mobileFont = props.mobileFont ? props.mobileFont : false;
        this.dove = props.dove ? props.dove : false;

    };

    componentDidUpdate(propsPrecedenti) {
      if (this.props.context01details !== propsPrecedenti.context01details) {
        this.setState({context01details: this.props.context01details});
      }
      if (this.props.context02details !== propsPrecedenti.context02details) {
        this.setState({context02details: this.props.context02details});
      }
    }

    // activeButton = () => {
    //     this.setState({ checkBox1: !this.state.checkBox1 })
    //     console.log("Amid checkbox", this.state.checkBox1)
    //     this.props.controller(this.state.checkBox1);

    // }
    RadioVerTwoCB(info) {
        this.props.callback(info);
    }

    radio1 = () => {
        this.setState({ radio1: true, radio2: false })
        // console.log("function radio1 -->  radio2, radio1",this.state.radio2, !this.state.radio1)
        this.RadioVerTwoCB("0");
    }

    radio2 = () => {
        this.setState({ radio1: false, radio2: true })
        // console.log("function radio2 -->  radio2, radio1",this.state.radio2, !this.state.radio1)
        this.RadioVerTwoCB("1");
    }

    render() {
        console.log("XXX radiobtn states: ", this.state);

        return (
            <div>

                {!this.mobileFont ?
                    <div>
                        {this.state.justFirst == "true" && <div>
                            <label className={this.state.radio1 ? "containerrdvtb" : "containerrdvtt"}>{this.state.context01}<br /><span style={{fontSize: '0.8em', fontStyle: 'italic'}}>{this.state.context01details}</span>
                                {(this.state.justFirst == "true") ? <input defaultChecked type="radio" name="radio" onChange={this.radio1} /> : <input type="radio" name="radio" onChange={this.radio1} />}
                                <span className="checkmark"></span>
                            </label>
                            <div className={this.dove ? "spacervtbd" : "spacervtb"} />
                        </div>}
                        {this.state.justSecond == "true" && <label className={this.state.radio2 ? "containerrdvtb" : "containerrdvtt"}>{this.state.context02}<br /><span style={{fontSize: '0.8em', fontStyle: 'italic'}}>{this.state.context02details}</span>
                            {(this.state.justFirst == "false" && this.state.justSecond == "true") ? <input defaultChecked type="radio" name="radio" onChange={this.radio2} /> : <input type="radio" name="radio" onChange={this.radio2} />}
                            <span className="checkmark"></span>
                        </label>}
                    </div> : null
                }
                {this.mobileFont ?
                    <div>
                        {this.state.justFirst == "true" && <div>
                            <label className={this.state.radio1 ? ((isMobileOnly || isAndroid) ? "containerrdvtbs" : "containerrdvtbst") : ((isMobileOnly || isAndroid) ? "containerrdvtts" : "containerrdvttst")}>{this.state.context01}<br /><span style={{fontSize: '0.8em', fontStyle: 'italic'}}>{this.state.context01details}</span>
                                {(this.state.justFirst == "true") ? <input defaultChecked type="radio" name="radio" onChange={this.radio1} /> : <input type="radio" name="radio" onChange={this.radio1} />}
                                <span className="checkmark"></span>
                            </label>
                            <div className="spacervtm" />
                        </div>}
                        {this.state.justSecond == "true" && <label className={this.state.radio2 ? ((isMobileOnly || isAndroid) ? "containerrdvtbs" : "containerrdvtbst") : ((isMobileOnly || isAndroid) ? "containerrdvtts" : "containerrdvttst")}>{this.state.context02}<br /><span style={{fontSize: '0.8em', fontStyle: 'italic'}}>{this.state.context02details}</span>
                            {(this.state.justFirst == "false" && this.state.justSecond == "true") ? <input defaultChecked type="radio" name="radio" onChange={this.radio2} /> : <input type="radio" name="radio" onChange={this.radio2} />}
                            <span className="checkmark"></span>
                        </label>}
                    </div> : null
                }
                {/* <label class="containerchtb" onChange={this.activeButton}>{this.state.context1}
                    <input type="checkbox" />
                    <span class="checkmark"></span>
                </label> */}

            </div>
        );
    }
}

export default RadioVerTwo;


// WEBPACK FOOTER //
// ./src/assets/components/radiobtn/RadioVerTwo.js